export const HOME_STAT_TITLES: Record<string, string> = {
  nTot: 'MLS count',
  ofCustomers: 'ClientBAY customers',
  ofCustomerTransaction: 'FinancialBAY customers',
};

/** Narrows an untyped API counter to what `StatTile` renders. */
export const toStatValue = (value: unknown): string | number | null =>
  typeof value === 'string' || typeof value === 'number' ? value : null;
